<script setup>
import { onBeforeMount, ref } from 'vue';

onBeforeMount(() => {
  if (!document.cookie.includes('locale')) {
    document.cookie = 'locale=hu';
  }
})

</script>

<template>
  <router-view/>

</template>

<style>
</style>
